import React, { memo } from 'react'
import { useWindowSize } from 'tve/components/appointment_grid/hooks'
import Desktop from 'tve/components/appointment_grid/desktop'
import Mobile from 'tve/components/appointment_grid/mobile'

const Switcher = memo((props) => {
  const size = useWindowSize()

  if (size.width == undefined || size.width >= 1024) {
    return <Desktop {...props} />
  }
  return <Mobile {...props} />
})
Switcher.displayName = 'Switcher'

export default Switcher
